"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icons = require("../Icons");
var _AlertModule = _interopRequireDefault(require("./Alert.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Alert = _ref => {
  var className = _ref.className,
    variant = _ref.variant,
    children = _ref.children,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_AlertModule.default.Container, {
      [_AlertModule.default.isFilled]: isFilled
    }, className),
    "data-variant": variant
  }, IconVariant[variant], /*#__PURE__*/_react.default.createElement("div", null, children));
};
exports.Alert = Alert;
var IconVariant = {
  success: /*#__PURE__*/_react.default.createElement(_Icons.IconCheck, {
    size: 16,
    isFilled: true
  }),
  error: /*#__PURE__*/_react.default.createElement(_Icons.IconAlertCircle, {
    size: 16,
    isFilled: true
  }),
  warning: /*#__PURE__*/_react.default.createElement(_Icons.IconAlertCircle, {
    size: 16,
    isFilled: true
  }),
  info: /*#__PURE__*/_react.default.createElement(_Icons.IconInfoCircle, {
    size: 16,
    isFilled: true
  })
};
//# sourceMappingURL=Alert.js.map